<!--
 * @Description: 短信状态回传
 * @Version: 1.0
 * @Autor: zhaoyy
 * @Date: 2021-12-31 09:20:40
 * @LastEditors: zhaoyy
 * @LastEditTime: 2022-01-04 16:40:13
-->
<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span class="main-r_top_nav active">在线文档</span>
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom">
      <online-doc :onlineData="onlineData">
        <template #api_addr_info>
          <p class="api_addr_info">地址：使用接入方提供的URL</p>
          <p class="api_addr_info">请求方法：<span>POST</span></p>
          <p class="api_addr_info">
            数据类型：<span>X-WWW-FORM-URLENCODED </span>
          </p>
          <p class="api_addr_info">响应类型：<span>JSON</span></p>
        </template>
      </online-doc>
    </div>
    <!-- 在线文档 END -->
  </div>
</template>

<script>
import onlineDoc from '../components/onlineDoc'
export default {
  components: { onlineDoc },
  data() {
    return {
      onlineData: {
        //接口描述
        apiDesc: '短信回执接口将短信发送状态通知到客户，客户需要在开放平台配置回传地址。',
        //参数描述  START
        postDataList: [
          //   请求头参数
          {
            title: 'Headers',
            value: [
              {
                name: 'apiAccount',
                type: 'Number',
                require: 'Y',
                normal: '',
                describe: '接入方在平台的api账户标识'
              },
              {
                name: 'digest',
                type: 'String',
                require: 'Y',
                normal: '',
                describe: '签名字符串'
              },
              {
                name: 'timestamp',
                type: 'Number',
                require: 'Y',
                normal: '',
                describe: '时间戳，毫秒'
              }
            ]
          },
          {
            title: '请求参数',
            value: [
              {
                name: 'bizContent',
                type: 'String',
                require: 'Y',
                normal: '业务参数',
                describe: '业务参数模块内json格式的string类型'
              }
            ]
          },
          {
            title: '业务参数',
            value: [
              {
                name: 'msgId',
                type: 'String',
                require: 'Y',
                normal: '',
                describe: '短信凭证ID，可作为更新回执的凭证'
              },
              {
                name: 'result',
                type: 'String',
                require: 'Y',
                normal: '',
                describe: '响应结果'
              },
              {
                name: 'errorDesc',
                type: 'String',
                require: 'N',
                normal: '',
                describe: '失败原因说明'
              },
              {
                name: 'smsCount',
                type: 'Integer',
                require: 'Y',
                normal: '',
                describe: '短信条数'
              }
            ]
          }
        ],
        //参数描述  END
        //报文描述 start
        responseDataList: [
          //   响应参数
          {
            title: '响应参数',
            value: [
              {
                name: 'code',
                type: 'String',
                require: 'Y',
                normal: '',
                describe: '返回码，见附录'
              },
              {
                name: 'msg',
                type: 'String',
                require: 'Y',
                normal: '',
                describe: '描述'
              },
              {
                name: 'data',
                type: 'Object',
                require: 'Y',
                normal: '',
                describe: '业务数据'
              }
            ]
          }
        ],
        //请求示例
        requestCode: `Header：
    apiAccount=1362
    digest=U40e5sumorgd3YgZzU61Mw==
    timestamp=1565238848921

Body：
    bizContent= {
    "msgId": "341507679191044158",
    "result": "请求成功",
    "errorDesc": "",
    "smsCount": 10
}`,
        //返回示例
        responseCode: JSON.parse(`{
    "code": "1",
    "msg": "success",
    "data": "SUCCESS"
}
`),
        //错误代码提示
        errcodeJson: []
      }
    }
  },
  created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '../../css/apiTest.scss';
</style>
